import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faLock, faFingerprint, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import PasskeyManager from '../../../components/PasskeyManager/PasskeyManager.js'
import PasswordForm from '../../../components/PasswordForm/PasswordForm.js'

import { boxvar2_1, boxvar2_2, boxvar4, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import './ProfilSecurity.css'
import './MProfilSecurity.css'

import Cookies from 'universal-cookie'


export default function ProfilSecurity() {

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    var isMigrate = new URLSearchParams(window.location.search).get("migrate") === "1"
    var [userMe, setUserMe] = useState(null)

    useEffect(() => {
        getUserMe()
    }, [])

    async function getUserMe() {
        try {
            const res = await fetch(URL_MAINAPI + "/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            })
            if (res.status === 200) setUserMe(await res.json())
        } catch (err) {
            setUserMe(null)
        }
    }

    var hasPassword = !!(userMe && userMe.haspassword)

    return (
        <div className='mainCon page' id='mainCon'>

            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Accountsicherheit</title>
                <meta property="og:title" content="Accountsicherheit" />
                <meta property="og:description" content="Passkeys und Passwort verwalten" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section security-page' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Accountsicherheit</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    🔐 Accountsicherheit
                </motion.h1>
                <p className='section-sub'>Lege fest, wie du dich bei Helferzeit anmeldest. Der E-Mail-Link funktioniert immer zusätzlich.</p>

                {(isMigrate) ? (
                    <div className='card security-migrate-banner'>
                        <FontAwesomeIcon icon={faCircleInfo} />
                        <div>
                            <b>Willkommen bei Helferzeit!</b>
                            <p>Du hast dich per E-Mail-Link angemeldet. Richte jetzt einen Passkey oder ein Passwort ein – dann geht der Login künftig ohne E-Mail.</p>
                        </div>
                    </div>
                ) : null}

                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='security-section'>
                    <div className='card security-card' id='passkeys'>
                        <div className='security-headline'>
                            <span className='security-icon'><FontAwesomeIcon icon={faFingerprint} /></span>
                            <h3>Passkeys</h3>
                            <span className='badge badge-open'>Empfohlen</span>
                        </div>
                        <p className='security-intro'>Melde dich ohne Passwort an – mit Face ID, Touch ID, Windows Hello oder deinem Passwortmanager (z. B. 1Password).</p>
                        <PasskeyManager />
                    </div>
                </motion.div>

                <motion.div variants={boxvar2_2} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='security-section'>
                    <div className='card security-card' id='passwort'>
                        <div className='security-headline'>
                            <span className='security-icon'><FontAwesomeIcon icon={faLock} /></span>
                            <h3>{hasPassword ? 'Passwort ändern' : 'Passwort festlegen'}</h3>
                        </div>
                        <p className='security-intro'>{hasPassword ? 'Vergib hier ein neues Passwort für den Login mit E-Mail und Passwort.' : 'Mit einem Passwort kannst du dich direkt mit E-Mail und Passwort anmelden.'}</p>
                        <PasswordForm hasPassword={hasPassword} />
                    </div>
                </motion.div>

                <div className='security-back'>
                    <a className="action_third_a" href={'/profil'}>{isMigrate ? 'Überspringen' : 'Zurück zum Profil'}</a>
                </div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
